import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './messages.js';

Vue.use(VueI18n);

export const resolveSupportedLocale = (locale) => {
  return locale === 'en' || locale === 'cs' ? locale : 'en';
};

export const i18n = new VueI18n({
  locale: resolveSupportedLocale(localStorage.getItem('locale')),
  messages,
});

export const setAppLocale = (locale) => {
  const resolvedLocale = resolveSupportedLocale(locale);

  localStorage.setItem('locale', resolvedLocale);
  i18n.locale = resolvedLocale;

  return resolvedLocale;
};
